import { updateProfile } from 'flow/actions/profile-actions';
import Loading from 'flow/components/ui-components/Loading';
import Button from 'flow/components/ui-components/Button';
import InputField from 'flow/components/ui-components/InputField';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';
import { fromJS } from 'immutable';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import Page from '../Page';

const ProfileName = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, profileKey } = useParams<{
        extensionKey: ExtensionKey;
        profileKey: ProfileKey;
    }>();

    const { getProfile } = useProfiles(extensionKey);

    const profile = getProfile(profileKey);

    const [name, setName] = useState<string>();

    useEffect(() => {
        setName(profile?.get('description'));
    }, [profile, profileKey]);

    if (!profile) {
        return <Loading />;
    }

    const onSubmit = () => {
        dispatch(
            updateProfile(
                extensionKey,
                fromJS({
                    key: profileKey,
                    description: name,
                }),
            ),
        );

        history.push(
            generatePath(routes['settings.profiles.profileKey'], {
                extensionKey,
                profileKey,
            }),
        );
    };

    return (
        <Page
            header={profile.get('description')}
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.profiles.profileKey'], {
                        extensionKey,
                        profileKey,
                    }),
                )
            }
        >
            <InputField
                label={i18next.t('pbx.name')}
                value={name}
                onChange={(e) => setName(e.target.value)}
                disabled={!profile.get('editable')}
            />

            <div className="mt-6 flex justify-end">
                <Button
                    color="primary"
                    className="min-w-max px-5"
                    onClick={onSubmit}
                    disabled={!profile.get('editable') || !name}
                >
                    {i18next.t('navigate.save')}
                </Button>
            </div>
        </Page>
    );
};

export default ProfileName;
